import {createApi} from "@reduxjs/toolkit/query/react"
import baseQuery from "../../utils/apiIIKOConfig"
import {
    ICreateTelegramNotificationResponse,
    ITelegramNotificationDetailsResponse,
    ITelegramNotificationListParams,
    ITelegramNotificationListResponse,
    ITelegramNotificationLogsParams,
    ITelegramNotificationLogsResponse,
    ITelegramNotificationSavePayload,
    IUpdateTelegramNotificationParams
} from "./TelegramNotificationApiTypes"

const BASE_URL = "/v1/telegram-notifications"

export const telegramNotificationApi = createApi({
    reducerPath: "telegramNotificationApi",
    baseQuery,
    tagTypes: ["telegramNotifications", "telegramNotificationLogs"],
    endpoints: (build) => ({
        getTelegramNotifications: build.query<ITelegramNotificationListResponse, ITelegramNotificationListParams>({
            query: (body) => ({
                url: `${BASE_URL}/list`,
                method: "POST",
                body
            }),
            providesTags: ["telegramNotifications"]
        }),
        getTelegramNotificationById: build.query<ITelegramNotificationDetailsResponse, number>({
            query: (id) => ({
                url: `${BASE_URL}/${id}`,
                method: "GET"
            }),
            providesTags: (_result, _error, id) => [{type: "telegramNotifications", id}]
        }),
        getTelegramNotificationLogs: build.query<ITelegramNotificationLogsResponse, ITelegramNotificationLogsParams>({
            query: ({id, ...body}) => ({
                url: `${BASE_URL}/${id}/logs`,
                method: "POST",
                body
            }),
            providesTags: (_result, _error, {id}) => [{type: "telegramNotificationLogs", id}]
        }),
        createTelegramNotification: build.mutation<ICreateTelegramNotificationResponse, ITelegramNotificationSavePayload>({
            query: (body) => ({
                url: BASE_URL,
                method: "POST",
                body
            }),
            invalidatesTags: ["telegramNotifications"]
        }),
        updateTelegramNotification: build.mutation<void, IUpdateTelegramNotificationParams>({
            query: ({id, ...body}) => ({
                url: `${BASE_URL}/${id}`,
                method: "PUT",
                body
            }),
            invalidatesTags: (_result, _error, {id}) => ["telegramNotifications", {type: "telegramNotifications", id}]
        }),
        deleteTelegramNotification: build.mutation<void, number>({
            query: (id) => ({
                url: `${BASE_URL}/${id}`,
                method: "DELETE"
            }),
            invalidatesTags: ["telegramNotifications"]
        }),
        stopTelegramNotification: build.mutation<void, number>({
            query: (id) => ({
                url: `${BASE_URL}/${id}/stop`,
                method: "PATCH"
            }),
            invalidatesTags: (_result, _error, id) => ["telegramNotifications", {type: "telegramNotifications", id}]
        }),
        resumeTelegramNotification: build.mutation<void, number>({
            query: (id) => ({
                url: `${BASE_URL}/${id}/resume`,
                method: "PATCH"
            }),
            invalidatesTags: (_result, _error, id) => ["telegramNotifications", {type: "telegramNotifications", id}]
        })
    })
})

export const {
    useGetTelegramNotificationsQuery,
    useGetTelegramNotificationByIdQuery,
    useGetTelegramNotificationLogsQuery,
    useCreateTelegramNotificationMutation,
    useUpdateTelegramNotificationMutation,
    useDeleteTelegramNotificationMutation,
    useStopTelegramNotificationMutation,
    useResumeTelegramNotificationMutation
} = telegramNotificationApi
